export interface DemoSpell {
  text: string;
  html: string;
  css: string;
  js: string;
}

export const DEMO_SPELLS: DemoSpell[] = [
  {
    text: "Abracadabra! Watch my spell unfold... this is just a glimpse of my full powers!",
    html: `<div class="spell-container">
  <div class="cauldron">
    <div class="cauldron-body"></div>
    <div class="bubble b1"></div>
    <div class="bubble b2"></div>
    <div class="bubble b3"></div>
    <div class="bubble b4"></div>
    <div class="bubble b5"></div>
  </div>
  <h1 class="spell-title">Merlin's Magic</h1>
  <p class="spell-text">The spell is too powerful for a demo!</p>
  <p class="spell-cta">This is just a glimpse of my full powers</p>
  <div class="sparkles">
    <span class="sparkle s1">&#10022;</span>
    <span class="sparkle s2">&#10022;</span>
    <span class="sparkle s3">&#10022;</span>
    <span class="sparkle s4">&#10022;</span>
    <span class="sparkle s5">&#10022;</span>
    <span class="sparkle s6">&#10022;</span>
  </div>
</div>`,
    css: `* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #0a0a1a;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}

.spell-container {
  text-align: center;
  position: relative;
}

.cauldron {
  position: relative;
  width: 120px;
  height: 100px;
  margin: 0 auto 2rem;
}

.cauldron-body {
  width: 120px;
  height: 80px;
  background: linear-gradient(135deg, #2d1b69, #1a0a3e);
  border-radius: 0 0 50% 50%;
  position: absolute;
  bottom: 0;
  box-shadow: 0 0 30px rgba(124, 58, 237, 0.4);
}

.bubble {
  position: absolute;
  border-radius: 50%;
  background: rgba(124, 58, 237, 0.6);
  animation: bubbleUp 2s ease-in-out infinite;
}

.b1 { width: 12px; height: 12px; left: 30px; bottom: 60px; animation-delay: 0s; }
.b2 { width: 8px; height: 8px; left: 55px; bottom: 65px; animation-delay: 0.4s; }
.b3 { width: 10px; height: 10px; left: 75px; bottom: 55px; animation-delay: 0.8s; }
.b4 { width: 6px; height: 6px; left: 45px; bottom: 70px; animation-delay: 1.2s; }
.b5 { width: 9px; height: 9px; left: 65px; bottom: 60px; animation-delay: 1.6s; }

@keyframes bubbleUp {
  0% { transform: translateY(0) scale(1); opacity: 0.8; }
  50% { opacity: 1; }
  100% { transform: translateY(-80px) scale(0.3); opacity: 0; }
}

.spell-title {
  font-size: 2.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #7c3aed, #a78bfa, #ec4899, #7c3aed);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shimmer 3s ease-in-out infinite;
  margin-bottom: 0.75rem;
}

@keyframes shimmer {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.spell-text {
  color: #a78bfa;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  animation: fadeIn 1s ease-out;
}

.spell-cta {
  color: #94a3b8;
  font-size: 0.9rem;
  animation: fadeIn 1.5s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.sparkles {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
}

.sparkle {
  position: absolute;
  color: #a78bfa;
  animation: float 3s ease-in-out infinite;
}

.s1 { top: 15%; left: 10%; font-size: 1.5rem; animation-delay: 0s; }
.s2 { top: 25%; right: 15%; font-size: 1rem; animation-delay: 0.5s; }
.s3 { bottom: 30%; left: 20%; font-size: 1.2rem; animation-delay: 1s; }
.s4 { top: 40%; right: 25%; font-size: 0.8rem; animation-delay: 1.5s; }
.s5 { bottom: 20%; right: 10%; font-size: 1.4rem; animation-delay: 2s; }
.s6 { top: 60%; left: 8%; font-size: 1.1rem; animation-delay: 2.5s; }

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); opacity: 0.4; }
  50% { transform: translateY(-20px) rotate(180deg); opacity: 1; }
}

@media (max-width: 480px) {
  .spell-title { font-size: 1.8rem; }
  .spell-text { font-size: 0.95rem; }
  .cauldron { width: 90px; height: 75px; margin-bottom: 1.5rem; }
  .cauldron-body { width: 90px; height: 60px; }
}`,
    js: `// Merlin's magic particles
const canvas = document.createElement('canvas');
canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:10';
document.body.appendChild(canvas);
const ctx = canvas.getContext('2d');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

const particles = [];
const colors = ['#7c3aed', '#a78bfa', '#ec4899', '#c084fc', '#818cf8'];

function createParticle() {
  return {
    x: Math.random() * canvas.width,
    y: canvas.height + 10,
    vx: (Math.random() - 0.5) * 2,
    vy: -(Math.random() * 3 + 1),
    size: Math.random() * 4 + 1,
    color: colors[Math.floor(Math.random() * colors.length)],
    alpha: 1,
    decay: Math.random() * 0.015 + 0.005,
  };
}

function animate() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (particles.length < 60) particles.push(createParticle());

  for (let i = particles.length - 1; i >= 0; i--) {
    const p = particles[i];
    p.x += p.vx;
    p.y += p.vy;
    p.alpha -= p.decay;
    if (p.alpha <= 0) { particles.splice(i, 1); continue; }
    ctx.globalAlpha = p.alpha;
    ctx.fillStyle = p.color;
    ctx.beginPath();
    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
  }
  requestAnimationFrame(animate);
}
animate();`,
  },
  {
    text: "A wizard never codes alone... but in demo mode, I work solo! Unlock the real magic to see what I can really do!",
    html: `<div class="magic-scene">
  <div class="wand">
    <div class="wand-stick"></div>
    <div class="wand-tip"></div>
    <div class="wand-trail"></div>
  </div>
  <div class="magic-text">
    <h1>Spellcasting...</h1>
    <p class="sub">I can build entire apps with a single prompt</p>
    <p class="cta">Unlock the real magic to see what I can do</p>
  </div>
  <div class="shooting-stars">
    <div class="streak streak-1"></div>
    <div class="streak streak-2"></div>
    <div class="streak streak-3"></div>
    <div class="streak streak-4"></div>
  </div>
  <div class="stars">
    <div class="star star-1"></div>
    <div class="star star-2"></div>
    <div class="star star-3"></div>
    <div class="star star-4"></div>
    <div class="star star-5"></div>
  </div>
</div>`,
    css: `* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #0f0f23;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}

.magic-scene { text-align: center; position: relative; z-index: 2; }

.wand {
  position: relative;
  width: 200px;
  height: 120px;
  margin: 0 auto 2rem;
  animation: wandWave 2s ease-in-out infinite;
}

.wand-stick {
  width: 4px;
  height: 80px;
  background: linear-gradient(to top, #8b5e3c, #d4a574);
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) rotate(-30deg);
  transform-origin: bottom center;
  border-radius: 2px;
}

.wand-tip {
  width: 10px;
  height: 10px;
  background: #fbbf24;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  left: calc(50% - 20px);
  box-shadow: 0 0 20px #fbbf24, 0 0 40px rgba(251, 191, 36, 0.5);
  animation: glow 1s ease-in-out infinite alternate;
}

.wand-trail {
  position: absolute;
  top: 5px;
  left: calc(50% - 25px);
  width: 60px;
  height: 60px;
  border: 2px solid rgba(251, 191, 36, 0.3);
  border-radius: 50%;
  animation: trailPulse 1.5s ease-in-out infinite;
}

@keyframes wandWave {
  0%, 100% { transform: rotate(-5deg); }
  50% { transform: rotate(5deg); }
}

@keyframes glow {
  from { box-shadow: 0 0 20px #fbbf24, 0 0 40px rgba(251, 191, 36, 0.5); }
  to { box-shadow: 0 0 30px #fbbf24, 0 0 60px rgba(251, 191, 36, 0.8); }
}

@keyframes trailPulse {
  0% { transform: scale(0.5); opacity: 1; }
  100% { transform: scale(2); opacity: 0; }
}

.magic-text h1 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #fbbf24;
  text-shadow: 0 0 20px rgba(251, 191, 36, 0.4);
  margin-bottom: 0.75rem;
  animation: textPulse 2s ease-in-out infinite;
}

@keyframes textPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.sub {
  color: #94a3b8;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.cta {
  color: #64748b;
  font-size: 0.85rem;
}

.shooting-stars {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
  z-index: 0;
}

.streak {
  position: absolute;
  width: 2px;
  height: 60px;
  background: linear-gradient(to bottom, rgba(251, 191, 36, 0), rgba(251, 191, 36, 0.8), rgba(251, 191, 36, 0));
  border-radius: 1px;
  transform: rotate(35deg);
  animation: shoot 3s ease-in infinite;
  opacity: 0;
}

.streak-1 { top: -60px; left: 15%; animation-delay: 0s; }
.streak-2 { top: -60px; left: 55%; animation-delay: 0.8s; height: 45px; }
.streak-3 { top: -60px; left: 80%; animation-delay: 1.6s; height: 70px; }
.streak-4 { top: -60px; left: 35%; animation-delay: 2.4s; height: 50px; }

@keyframes shoot {
  0% { transform: rotate(35deg) translateY(0); opacity: 0; }
  10% { opacity: 0.8; }
  70% { opacity: 0.3; }
  100% { transform: rotate(35deg) translateY(calc(100vh + 120px)); opacity: 0; }
}

.stars { position: fixed; top: 0; left: 0; right: 0; bottom: 0; pointer-events: none; z-index: 0; }

.star {
  position: absolute;
  width: 3px;
  height: 3px;
  background: white;
  border-radius: 50%;
  animation: twinkle 2s ease-in-out infinite;
}

.star-1 { top: 10%; left: 20%; animation-delay: 0s; }
.star-2 { top: 30%; right: 15%; animation-delay: 0.4s; }
.star-3 { bottom: 25%; left: 10%; animation-delay: 0.8s; }
.star-4 { top: 50%; right: 30%; animation-delay: 1.2s; }
.star-5 { bottom: 15%; right: 20%; animation-delay: 1.6s; }

@keyframes twinkle {
  0%, 100% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.5); }
}

@media (max-width: 480px) {
  .magic-text h1 { font-size: 1.6rem; }
  .wand { width: 150px; height: 90px; margin-bottom: 1.5rem; }
}`,
    js: `// All animation handled by CSS — clean and simple`,
  },
  {
    text: "My enchantments are legendary... but this is just a taste! The real magic awaits!",
    html: `<div class="potion-lab">
  <div class="flask">
    <div class="flask-liquid"></div>
    <div class="flask-glow"></div>
  </div>
  <h1 class="lab-title">Potion Brewing...</h1>
  <div class="formula">
    <span class="ingredient i1">HTML</span>
    <span class="plus">+</span>
    <span class="ingredient i2">CSS</span>
    <span class="plus">+</span>
    <span class="ingredient i3">JS</span>
    <span class="equals">=</span>
    <span class="ingredient i4">Magic</span>
  </div>
  <p class="lab-cta">The real potions are waiting for you</p>
</div>`,
    css: `* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #0a0a1a;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}

.potion-lab { text-align: center; }

.flask {
  width: 80px;
  height: 120px;
  margin: 0 auto 2rem;
  position: relative;
}

.flask-liquid {
  position: absolute;
  bottom: 0;
  left: 10px;
  right: 10px;
  height: 70%;
  background: linear-gradient(to top, #7c3aed, #a78bfa);
  border-radius: 0 0 30px 30px;
  animation: liquidBubble 2s ease-in-out infinite;
}

.flask-glow {
  position: absolute;
  bottom: -10px;
  left: -10px;
  right: -10px;
  height: 50%;
  background: radial-gradient(ellipse, rgba(124, 58, 237, 0.3), transparent);
  animation: glowPulse 1.5s ease-in-out infinite alternate;
}

@keyframes liquidBubble {
  0%, 100% { height: 70%; }
  50% { height: 75%; }
}

@keyframes glowPulse {
  from { opacity: 0.5; }
  to { opacity: 1; }
}

.lab-title {
  font-size: 2rem;
  font-weight: 700;
  color: #a78bfa;
  margin-bottom: 1.5rem;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.formula {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.ingredient {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  animation: ingredientPop 0.5s ease-out backwards;
}

.i1 { background: rgba(239, 68, 68, 0.2); color: #fca5a5; animation-delay: 0.2s; }
.i2 { background: rgba(59, 130, 246, 0.2); color: #93c5fd; animation-delay: 0.4s; }
.i3 { background: rgba(234, 179, 8, 0.2); color: #fde047; animation-delay: 0.6s; }
.i4 { background: rgba(124, 58, 237, 0.3); color: #c4b5fd; animation-delay: 1s; font-size: 1.1rem; }

.plus, .equals {
  color: #475569;
  font-size: 1.2rem;
  font-weight: 700;
}

@keyframes ingredientPop {
  from { opacity: 0; transform: scale(0.5) translateY(10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.lab-cta {
  color: #64748b;
  font-size: 0.85rem;
  animation: fadeIn 2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (max-width: 480px) {
  .lab-title { font-size: 1.5rem; }
  .ingredient { padding: 0.4rem 0.75rem; font-size: 0.8rem; }
  .flask { width: 60px; height: 90px; margin-bottom: 1.5rem; }
}`,
    js: `// Color-changing background particles
const colors = ['#7c3aed', '#a78bfa', '#ec4899', '#3b82f6', '#fbbf24'];
const container = document.querySelector('.potion-lab');

setInterval(() => {
  const dot = document.createElement('div');
  const color = colors[Math.floor(Math.random() * colors.length)];
  const size = Math.random() * 6 + 2;
  const x = Math.random() * 100;
  Object.assign(dot.style, {
    position: 'fixed',
    left: x + '%',
    bottom: '-10px',
    width: size + 'px',
    height: size + 'px',
    borderRadius: '50%',
    background: color,
    opacity: '0.6',
    pointerEvents: 'none',
    zIndex: '0',
    transition: 'all 4s ease-out',
  });
  document.body.appendChild(dot);
  requestAnimationFrame(() => {
    dot.style.bottom = '110%';
    dot.style.opacity = '0';
  });
  setTimeout(() => dot.remove(), 4500);
}, 150);`,
  },
  {
    text: "Summoning the aurora borealis... my code paints the sky! Just imagine what I can do with real projects!",
    html: `<div class="aurora-scene">
  <div class="mountains">
    <div class="mountain m1"></div>
    <div class="mountain m2"></div>
    <div class="mountain m3"></div>
  </div>
  <h1 class="aurora-title">Northern Lights</h1>
  <p class="aurora-sub">Code that paints the sky</p>
  <p class="aurora-cta">Imagine what I can do with your real projects</p>
</div>`,
    css: `* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #020815;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}

.aurora-scene {
  text-align: center;
  position: relative;
  z-index: 2;
}

.mountains {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  z-index: 1;
}

.mountain {
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
  border-style: solid;
}

.m1 {
  left: -5%;
  border-width: 0 200px 160px 200px;
  border-color: transparent transparent #0a1628 transparent;
}

.m2 {
  left: 30%;
  border-width: 0 250px 200px 250px;
  border-color: transparent transparent #0d1f3c transparent;
}

.m3 {
  right: -5%;
  border-width: 0 220px 140px 220px;
  border-color: transparent transparent #0a1628 transparent;
}

.aurora-title {
  font-size: 2.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #22d3ee, #34d399, #a78bfa, #22d3ee);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: auroraShimmer 4s ease-in-out infinite;
  margin-bottom: 0.75rem;
  position: relative;
  z-index: 3;
}

@keyframes auroraShimmer {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.aurora-sub {
  color: #5eead4;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  opacity: 0.8;
  position: relative;
  z-index: 3;
}

.aurora-cta {
  color: #475569;
  font-size: 0.85rem;
  position: relative;
  z-index: 3;
}

@media (max-width: 480px) {
  .aurora-title { font-size: 1.8rem; }
  .mountains { height: 120px; }
  .m1 { border-width: 0 120px 100px 120px; }
  .m2 { border-width: 0 150px 130px 150px; }
  .m3 { border-width: 0 130px 90px 130px; }
}`,
    js: `// Northern lights aurora effect
const canvas = document.createElement('canvas');
canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:0';
document.body.appendChild(canvas);
const ctx = canvas.getContext('2d');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

let time = 0;
const colors = [
  [34, 211, 238],  // cyan
  [52, 211, 153],  // emerald
  [167, 139, 250], // violet
  [56, 189, 248],  // sky
];

function drawAurora() {
  ctx.fillStyle = 'rgba(2, 8, 21, 0.08)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  for (let band = 0; band < 4; band++) {
    const color = colors[band % colors.length];
    const y = canvas.height * 0.15 + band * 40;

    ctx.beginPath();
    ctx.moveTo(0, y);

    for (let x = 0; x <= canvas.width; x += 4) {
      const wave = Math.sin(x * 0.003 + time + band * 0.8) * 50 +
                   Math.sin(x * 0.007 + time * 1.3 + band) * 25 +
                   Math.sin(x * 0.001 + time * 0.5) * 30;
      ctx.lineTo(x, y + wave);
    }

    ctx.lineTo(canvas.width, 0);
    ctx.lineTo(0, 0);
    ctx.closePath();

    const alpha = 0.04 + Math.sin(time + band) * 0.02;
    ctx.fillStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + alpha + ')';
    ctx.fill();
  }

  time += 0.015;
  requestAnimationFrame(drawAurora);
}
drawAurora();`,
  },
  {
    text: "Weaving a digital galaxy... every line of code creates a star! This is only a preview of my universe!",
    html: `<div class="galaxy-scene">
  <div class="galaxy-core"></div>
  <h1 class="galaxy-title">Code Galaxy</h1>
  <p class="galaxy-sub">Every line creates a new star</p>
  <div class="orbit o1"><div class="planet p1"></div></div>
  <div class="orbit o2"><div class="planet p2"></div></div>
  <div class="orbit o3"><div class="planet p3"></div></div>
  <p class="galaxy-cta">This is only a preview of my universe</p>
</div>`,
    css: `* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #030712;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}

.galaxy-scene {
  text-align: center;
  position: relative;
}

.galaxy-core {
  width: 24px;
  height: 24px;
  background: radial-gradient(circle, #fff, #a78bfa, transparent);
  border-radius: 50%;
  margin: 0 auto 2rem;
  box-shadow: 0 0 60px 20px rgba(167, 139, 250, 0.3), 0 0 120px 40px rgba(124, 58, 237, 0.15);
  animation: corePulse 3s ease-in-out infinite;
}

@keyframes corePulse {
  0%, 100% { box-shadow: 0 0 60px 20px rgba(167, 139, 250, 0.3), 0 0 120px 40px rgba(124, 58, 237, 0.15); }
  50% { box-shadow: 0 0 80px 30px rgba(167, 139, 250, 0.5), 0 0 160px 60px rgba(124, 58, 237, 0.25); }
}

.orbit {
  position: absolute;
  border: 1px solid rgba(167, 139, 250, 0.1);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.o1 { width: 120px; height: 120px; animation: spin 8s linear infinite; }
.o2 { width: 200px; height: 200px; animation: spin 14s linear infinite reverse; }
.o3 { width: 280px; height: 280px; animation: spin 20s linear infinite; }

@keyframes spin { to { transform: translate(-50%, -50%) rotate(360deg); } }

.planet {
  position: absolute;
  border-radius: 50%;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
}

.p1 { width: 8px; height: 8px; background: #22d3ee; box-shadow: 0 0 10px #22d3ee; }
.p2 { width: 10px; height: 10px; background: #a78bfa; box-shadow: 0 0 12px #a78bfa; }
.p3 { width: 6px; height: 6px; background: #f472b6; box-shadow: 0 0 8px #f472b6; }

.galaxy-title {
  font-size: 2.2rem;
  font-weight: 800;
  background: linear-gradient(135deg, #a78bfa, #818cf8, #f472b6, #a78bfa);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: auroraShimmer 3s ease-in-out infinite;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 2;
}

@keyframes auroraShimmer {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.galaxy-sub {
  color: #a78bfa;
  font-size: 1rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 2;
}

.galaxy-cta {
  color: #475569;
  font-size: 0.85rem;
  margin-top: 2rem;
  position: relative;
  z-index: 2;
}

@media (max-width: 480px) {
  .galaxy-title { font-size: 1.6rem; }
  .o1 { width: 90px; height: 90px; }
  .o2 { width: 150px; height: 150px; }
  .o3 { width: 210px; height: 210px; }
  .galaxy-core { margin-bottom: 1.5rem; }
}`,
    js: `// Twinkling star field
const canvas = document.createElement('canvas');
canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:0';
document.body.appendChild(canvas);
const ctx = canvas.getContext('2d');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

const stars = Array.from({ length: 200 }, () => ({
  x: Math.random() * canvas.width,
  y: Math.random() * canvas.height,
  size: Math.random() * 2 + 0.5,
  speed: Math.random() * 0.5 + 0.1,
  brightness: Math.random(),
  phase: Math.random() * Math.PI * 2,
}));

let time = 0;

function animate() {
  ctx.fillStyle = 'rgba(3, 7, 18, 0.2)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  stars.forEach(star => {
    const twinkle = 0.4 + 0.6 * Math.sin(time * star.speed * 2 + star.phase);
    const alpha = star.brightness * twinkle;

    ctx.beginPath();
    ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(167, 139, 250, ' + alpha + ')';
    ctx.fill();

    // Occasional shooting star
    if (Math.random() < 0.0003) {
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(star.x, star.y);
      ctx.lineTo(star.x + 40, star.y + 20);
      ctx.stroke();
    }
  });

  time += 0.016;
  requestAnimationFrame(animate);
}
animate();`,
  },
];

/**
 * Returns a random spell index that differs from the last used index.
 * Ensures users see a different spell each time.
 */
export const getRandomSpellIndex = (lastIndex: number): number => {
  if (DEMO_SPELLS.length <= 1) return 0;
  let next: number;
  do {
    next = Math.floor(Math.random() * DEMO_SPELLS.length);
  } while (next === lastIndex % DEMO_SPELLS.length);
  return next;
};

export const DEMO_GREETING =
  "Hey gorgeous! ✨ I'm **Merlin** — type anything and watch the magic happen 🪄";

/**
 * Builds the Markdown follow-up message shown after a demo spell completes.
 * Includes CTA, features list split by Learn/Build/Career, and example template links.
 */
export const buildDemoFollowUpMessage = (isSignedIn: boolean, isPaidUser: boolean): string => {
  const ctaLine = !isSignedIn
    ? 'Sign in to keep the magic forever and unlock my full powers!'
    : isPaidUser
      ? 'Head to your dashboard to unleash my full powers on real projects!'
      : 'Upgrade your plan to keep the magic forever and unlock my full powers!';

  return `${ctaLine}

---

**What you can do with BigDevSoon:**

**Learn**
- [Projects](https://bigdevsoon.me/projects) — 21 real-world apps to build step by step
- [Challenges](https://bigdevsoon.me/challenges) — 100 daily coding challenges
- [Problems](https://bigdevsoon.me/problems) — 40+ practice problems with tests

**Build**
- [Prototypes](https://bigdevsoon.me/prototypes) — Full-page web app prototypes
- [Code Frames](https://bigdevsoon.me/code-frames) — Embeddable code snippets
- Merlin AI — I can generate code, review it, roast it, and explain it!

**Career**
- [CV Builder](https://bigdevsoon.me/cv-builder) — Build ATS-friendly CVs
- [Classic Template](https://app.bigdevsoon.me/cv/1ef189d9-7f84-42d9-b047-32f182c0dc5a) — Single column, best for ATS
- [Modern Template](https://app.bigdevsoon.me/cv/4751ae69-e204-4212-a165-ca493c9f0d15) — Two columns, clean sidebar
- [Creative Template](https://app.bigdevsoon.me/cv/80d096a5-fefd-4cb9-80aa-b058ca913f7c) — Accent blocks, visual flair

---

**Try these demo templates:**
- [Vanilla Landing Page](/demo/vanilla-landing)
- [React Counter App](/demo/react-counter)
- [Vue Counter App](/demo/vue-counter)

Click **Remove Spell** below to restore your code, or reopen me anytime for a new spell!`;
};
